import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: false,
        themes: {
            light: {
                'app-bar': colors.blue.base,
                primary: '#3f296c',
                secondary: '#ffffff',

                primaryText: colors.green.accent1,
                textPrimary: '#ff00ff',
                background: '#61C3D9',
                mycolor: colors.purple.base,
                defaultTextColor: colors.green.darken1,
                error: '#ffffff',
            },
            dark: {
                // background: colors.pink.base,
                // mycolor: colors.purple.base
                // secondary: colors.blue.base,
                // primaryText: colors.green.accent1,
                // secondaryText: colors.green.base
            },
        },
        options: {
            customProperties: true
        },
    },
});
